<template>
	<div>
		<b-modal
			ref="modal-Create"
			@hidden="$emit('close')"
			cancel-title="Cancelar"
			scrollable
			size="xmd"
			no-close-on-backdrop
			title="Seleccione un avatar"
		>
			<div class="container-imagess">
				<div
					class="image-card"
					v-for="image in arrayImages"
					:class="image.selected ? 'card-opacity' : ''"
					:key="image.id"
				>
					<div class="cards">
						<div>
							<ViewImage
								:specimen="{
									id: image.id,
									url: image.url_image,
								}"
							/>
							<div>
								{{ image.alias }}
							</div>
						</div>

						<div class="container-check">
							<div @click="openModal(image.tournaments)">
								<div class="icon-eyess" style="border-radius: 5px; padding: 2px">
									{{ image.tournaments.length }}
								</div>
							</div>
						</div>
					</div>
					<div class="radio-button" @click="selectImage(image.id)">
						<div class="radio-button-icon" v-if="image.selected"></div>
					</div>
					<div class="d-flex flex-column justify-content-between align-items-center m-1">
						<FeatherIcon
							icon="EditIcon"
							class="text-warning cursor-pointer"
							@click="openUpdateAvatar(image)"
						/>
						<FeatherIcon
							icon="TrashIcon"
							class="text-danger cursor-pointer"
							@click="destroyImage(image.id)"
						/>
					</div>
				</div>
			</div>
			<template #modal-footer>
				<b-button variant="danger" @click="closeModal">Cancelar</b-button>
				<b-button variant="outline-primary" @click="save">Agregar</b-button>
			</template>
		</b-modal>

		<b-modal
			v-model="showUpdateAvatar"
			title="Actualizar Avatar"
			size="md"
			@hidden="selectedAvatar = []"
			@ok.prevent="updateImage"
			:ok-title="updateAvatarLoading ? 'Actualizando...' : 'Actualizar'"
			:ok-disabled="updateAvatarLoading || (!selectedAvatar.length && !alias)"
			:cancel-disabled="updateAvatarLoading"
		>
			<b-form-group label="1. Alias" label-for="alias" label-class="h5 font-weight-bold">
				<b-form-input
					id="alias"
					placeholder="Ingrese alias del avatar"
					v-model="alias"
					@input="(val) => (alias = alias.toUpperCase())"
				/>
			</b-form-group>
			<b-form-group label="2. Imagen" label-for="image" label-class="h5 font-weight-bold">
				<span class="mb-2">
					Si desea cambiar la imagen, seleccione una nueva. Si no se selecciona una nueva imagen, se mantendrá
					la actual.
				</span>
				<div class="d-flex flex-column align-items-center">
					<InputImages :multiple="false" single variant="primary" v-model="selectedAvatar" />
				</div>
			</b-form-group>
		</b-modal>

		<ModalInfoAvatar v-if="showInfo" @close="showInfo = false" :arrayTournamen="arrayTournamen" />
	</div>
</template>
<script>
import modalMixin from "@/mixins/modal.js"
import Ripple from "vue-ripple-directive"
import { getBase64 } from "@/helpers/functions"
import generalTournamentService from "@/services/tournament/general.service"
import ViewImage from "@/components/commons/ViewImage.vue"
import ModalInfoAvatar from "@/views/amg/tournaments/v2/components/ModalInfoAvatar.vue"
import InputImages from "@/components/commons/InputImages.vue"
export default {
	props: {
		idImage: null,
	},

	directives: { Ripple },
	components: {
		ViewImage,
		ModalInfoAvatar,
		InputImages,
	},
	mixins: [modalMixin],
	data() {
		return {
			alias: null,
			arrayImages: [],
			showInfo: false,
			arrayTournamen: [],
			selectedImage: {},
			selectedAvatar: [],
			selectedAvatarId: null,
			showUpdateAvatar: false,
			updateAvatarLoading: false,
		}
	},
	async mounted() {
		this.toggleModal("modal-Create")
	},

	async created() {
		this.isPreloading()
		try {
			await this.getImages()
		} catch (error) {
			console.log("error: ", error)
		} finally {
			this.isPreloading(false)
		}
	},
	methods: {
		openUpdateAvatar(row) {
			this.selectedAvatarId = row.id
			this.showUpdateAvatar = true
			this.selectedImage = row
			this.alias = row.alias
		},
		async updateImage() {
			this.updateAvatarLoading = true
			try {
				let avatarBase = null
				if (this.selectedAvatar.length) {
					avatarBase = await getBase64(this.selectedAvatar[0].file)
				}
				await generalTournamentService.updateImage(this.selectedAvatarId, {
					image: avatarBase,
					alias: this.alias,
				})
				this.showSuccessToast("Avatar actualizado correctamente")
				this.getImages()
				this.showUpdateAvatar = false
				this.selectedAvatar = []
				this.selectedAvatarId = null
				this.alias = null
			} catch (error) {
				this.showToast("danger", "top-right", "Error al actualizar el avatar", "AlertCircleIcon", "")
				console.log("error: ", error)
			} finally {
				this.updateAvatarLoading = false
			}
		},
		async destroyImage(id) {
			try {
				const { isConfirmed } = await this.showConfirmSwal()
				if (!isConfirmed) return
				await generalTournamentService.destroyImage(id)
				this.showToast("success", "top-right", "Imagen eliminada correctamente", "CheckIcon", "")
				this.getImages()
			} catch (error) {
				console.log("error: ", error)
			}
		},
		openModal(data) {
			this.arrayTournamen = data

			this.showInfo = true
		},
		async getImages() {
			const { data } = await generalTournamentService.indexImages()
			this.arrayImages = data.map((image, index) => ({
				...image,
				selected: false,
				// index: index,
			}))
		},
		closeModal() {
			this.$emit("close")
		},

		selectImage(selectedId) {
			this.arrayImages.forEach((image) => {
				if (image.id === selectedId) {
					image.selected = true
				} else {
					image.selected = false
				}
			})
		},
		save() {
			const filteredIds = this.arrayImages
				.filter((image) => {
					return image.selected === true
				})
				.map((image) => {
					return {
						id: image.id,
						image: image.url_image,
						url_thumb: image.url_thumb,
					}
				})

			const image = filteredIds[0]

			if (!image) {
				this.showToast(
					"warning",
					"top-right",
					"Seleccionar un Avatar",
					"AlertCircleIcon",
					"debes seleccionar un avatar"
				)
				return
			}

			this.$emit("getImage", image)
			this.$emit("close")
		},
	},
}
</script>
<style>
.checks {
	width: 20px;
	height: 20px;
	border-radius: 100%;
	background-color: red;
	display: flex;
	align-items: center;
	overflow: hidden;
	justify-content: center;
}

.cards {
	display: flex;
	padding-top: 1rem;
	padding-bottom: 1rem;
	gap: 1.5rem;

	padding-left: 2rem;
	padding-right: 2rem;
}
.image-card {
	display: flex;
	gap: 1rem;
	box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
	border-radius: 5px;
	justify-content: center;
	position: relative;
}

.radio-button {
	position: absolute;
	top: 0.3rem;
	right: 0.3rem;
	background-color: #e3e3e3;
	width: 20px;
	height: 20px;
	border-radius: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.radio-button-icon {
	width: 10px;
	height: 10px;
	background-color: var(--primary);
	border-radius: 100%;
}

.card-opacity {
	outline: 1.5px solid var(--primary);
}
.container-imagess {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	gap: 2rem;
}
.container-check {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.8rem;
}
.icon-eyess {
	width: 1.3rem;
	height: 1.3rem;
	background-color: #ea5455;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-left: -0.5rem;
	font-size: 0.9rem;
	color: white;
	font-weight: 800;
	cursor: pointer;
}
</style>
